import React, { Component } from 'react';
import jwt_decode from "jwt-decode";
import { withRouter} from 'react-router-dom';

import mixin from '../../../utils/mixin.js';

import { getCurrentUser } from '../../../api/Api.js';

import NavbarMenu from '../NavbarMenu/NavbarMenu.js';

import './ProfileForm.scss';

import ProfileForm from './ProfileForm.js';

const {methods} = mixin;

class Profile extends Component {

  constructor(props){
    
    super(props);

    let dev = localStorage.getItem('dev');
    if(dev == null || dev == undefined || dev == ''){
      this.props.history.push("/admin");
      window.location.reload();
    }

    dev = JSON.parse(dev);
    
    let token = localStorage.getItem('jwt');

    if(token){
      const decoded = jwt_decode(token);
      let date = new Date(decoded.exp * 1000);
      let mydate = new Date();
      
      if (date <= mydate) {
        this.logout();
      }
    }else{
      this.logout();
    }

    methods.G_changeLanguage('es');

    this.state = {
      loading: false,
      users: [],
      selected_user: null,
      action: null,
      development_id: dev.development_id,
      development: dev,
    }
  }

  logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("user");
    localStorage.removeItem("developments");
    this.props.history.push("/admin/login");
    window.location.reload();
  }

  componentDidMount() {
    
    this.setState({
      loading: true
    }, () => {
      Promise.all([this.dispatchUser()]).then(values => {
        
        this.setState({
            loading: false,
        });

      }, reason => {
          console.info(reason)
      });
    });
  }

  dispatchUser = () => new Promise((resolve, reject) => {
    // const { developmentId } = this.state
    
    getCurrentUser().then((res) => {
      this.setState({
        selected_user: res ,
      }, () => resolve('user data ok'));
    });
  });

  render() {
      const { users, loading } = this.state;

      if (loading) {
        return (
          <div className="h-100">
            <NavbarMenu development={this.state.development} logout={this.logout} />
            <div className="container-fluid pt-4 h-100">
              Cargando...
            </div>
          </div>
        );
      }

      return (
        <div className="h-100">
          <NavbarMenu development={this.state.development} logout={this.logout} />
          <div className="container-fluid h-100 ext-container">
            <div className="row h-100">
              <div className="col-12 col-md-12 pt-4 pb-5 only-panel">
                
                <div>
                  
                  {
                    this.state.selected_user && 
                    <ProfileForm user={this.state.selected_user} user_id={this.state.selected_user.user_id} />
                  }

                </div>
                
              </div>
              
            </div>
            
          </div>
        </div>
      );
  }

}

export default withRouter(Profile);